import './index.scss';

(function ($) {

  $('.js-collapsible', 'body').on('click', e => {
    const $toggle = $(e.currentTarget);
    const $collapse = $($toggle.attr('href'));

    setTimeout(() => {
      const isOpen = $collapse.hasClass('in');

      if (isOpen) {
        $toggle.find('.q-close').removeClass('hidden');
        $toggle.find('.q-open').addClass('hidden');
      } else {
        $toggle.find('.q-close').addClass('hidden');
        $toggle.find('.q-open').removeClass('hidden');
      }
    }, 500);
  });

})(jQuery);
